
const digest = '0b33ffeb9bae119b7d6f140956a65c3cb1ae0e4009e298640688118f65b24e83';
const classes = {"wrapper":"_wrapper_1gup1_5","fixed":"_fixed_1gup1_11","flexRow":"_flex-row_1gup1_14","scrollable":"_scrollable_1gup1_21","flagIcon":"_flag-icon_1gup1_47","flexTable":"_flex-table_1gup1_51","rowspan":"_rowspan_1gup1_80","column":"_column_1gup1_87","flexCell":"_flex-cell_1gup1_106","first":"_first_1gup1_116","header":"_header_1gup1_130","tableColumn":"_tableColumn_1gup1_150","flexWrap":"_flexWrap_1gup1_155"};
const css = `div {
  box-sizing: border-box;
}

._wrapper_1gup1_5 {
  display: flex;
  background-color: #ffffff;
  flex-direction: row;
}

._fixed_1gup1_11 {
  border-right: 1px solid #eaedf3;
}
._fixed_1gup1_11 ._flex-row_1gup1_14 {
  flex: 1;
}
._fixed_1gup1_11 ._flex-row_1gup1_14:only-child {
  align-items: flex-start;
}

._scrollable_1gup1_21 {
  flex: 1;
  overflow-x: auto;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._scrollable_1gup1_21::-webkit-scrollbar {
  display: block;
}
._scrollable_1gup1_21::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._scrollable_1gup1_21::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._scrollable_1gup1_21::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._scrollable_1gup1_21::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}

._flag-icon_1gup1_47 {
  margin-right: 0.1em;
}

._flex-table_1gup1_51 {
  display: flex;
  flex-flow: row wrap;
  border-left: solid 1px #eaedf3;
  transition: 0.5s;
}
._flex-table_1gup1_51:first-of-type {
  border-top: solid 1px #eaedf3;
  border-left: solid 1px #eaedf3;
}
._flex-table_1gup1_51:first-of-type ._flex-row_1gup1_14 {
  border-color: #eaedf3;
}
._flex-table_1gup1_51:hover {
  background: #F5F5F5;
  transition: 500ms;
}

._flex-row_1gup1_14 {
  text-align: left;
  border-bottom: solid 1px #eaedf3;
  font-size: 14px;
  font-family: Rubik, "sans-serif";
  font-weight: 400;
  color: #000000;
  align-items: center;
  display: flex;
}

._rowspan_1gup1_80 {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
}

._column_1gup1_87 {
  display: flex;
  flex-flow: column wrap;
  width: 75%;
  padding: 0;
}
._column_1gup1_87 ._flex-row_1gup1_14 {
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 0;
  border: 0;
  border-bottom: solid 1px #eaedf3;
}
._column_1gup1_87 ._flex-row_1gup1_14:hover {
  background: #F5F5F5;
  transition: 500ms;
}

._flex-cell_1gup1_106 {
  width: 33.3333333333%;
  text-align: left;
  padding: 0.5em 0.5em;
  border-right: solid 1px #eaedf3;
}
@media all and (max-width: 767px) {
  ._flex-row_1gup1_14 {
    width: 33.3333333333%;
  }
  ._flex-row_1gup1_14._first_1gup1_116 {
    width: 100%;
  }
  ._column_1gup1_87 {
    width: 100%;
  }
}
@media all and (max-width: 430px) {
  ._flex-table_1gup1_51 ._flex-row_1gup1_14 {
    border-bottom: 0;
  }
  ._flex-table_1gup1_51 ._flex-row_1gup1_14:last-of-type {
    border-bottom: solid 1px #eaedf3;
  }
  ._header_1gup1_130 ._flex-row_1gup1_14 {
    border-bottom: solid 1px;
  }
  ._flex-row_1gup1_14 {
    width: 100%;
  }
  ._flex-row_1gup1_14._first_1gup1_116 {
    width: 100%;
    border-bottom: solid 1px #eaedf3;
  }
  ._column_1gup1_87 {
    width: 100%;
  }
  ._column_1gup1_87 ._flex-row_1gup1_14 {
    border-bottom: solid 1px #eaedf3;
  }
  ._flex-cell_1gup1_106 {
    width: 100%;
  }
}
._tableColumn_1gup1_150 {
  color: #9ea0a5;
  padding: 10px 0;
}

._flexWrap_1gup1_155 {
  flex-wrap: nowrap;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  